import React, { useRef, useState, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";

import LoadingContext from "../../context/Loading/Loading";
import authService from "../../utilities/services/auth.service";

import {
  getMyEvents,
  getIncomingTransfers,
  acceptIncomingTransfers,
  getGuestList,
} from "../../utilities/api";

import {
  getNowInTimezone,
  getTimezoneDate,
  removeDuplicateTickets,
} from "../../utilities/helpers";

import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";

import { PageLoadingContainer } from "../PageLoadingContainer";
import { EmptyContainer } from "../EmptyContainer";
import { SwiperNavigationButtons } from "../SwiperNavigationButtons";
import { MyEventsSlider } from "./MyEventsSlider";
import { PackagesList } from "./PackagesList";
import { EventsList } from "./EventsList";

export default function MyEventsWrapper() {
  const { isLoading, showLoading, hideLoading } = useContext(LoadingContext);

  const { getUser } = authService;
  const user = getUser().user;
  const location = useLocation();

  const isScalper = user?.bulkPurchaser;
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);

  const [key, setKey] = useState("upcoming");

  const [orders, setOrders] = useState([]);

  const [eventOrders, setEventOrders] = useState([]);

  const [transfers, setTransfers] = useState([]);

  const [isAccepting, setIsAccepting] = useState({
    accepting: false,
    id: null,
  });

  const [guestLists, setGuestLists] = useState([]);

  const [packageOrders, setPackageOrders] = useState([]);

  useEffect(() => {
    showLoading();
    getMyTickets();
  }, []);

  const getMyTickets = async () => {
    try {
      const myUpcomingEvents = await getMyEvents();
      const orders = myUpcomingEvents.data;
      // event orders
      // filter out past events - have ended
      const eventOrders = orders?.filter(
        (order) => order?.event && order.event.status === "on_sale"
      );
      setEventOrders(eventOrders);

      // package orders
      // filter out past packages - when last event in package have ended
      const packageOrders = orders?.filter(
        (order) =>
          Boolean(order?.package) &&
          getTimezoneDate(
            order?.package?.endOfLastEvent,
            order?.timezone
          ).isSameOrAfter(getNowInTimezone(order?.timezone))
      );
      setPackageOrders(packageOrders);

      setOrders([...eventOrders, ...packageOrders]);

      setIsAccepting({
        accepting: false,
        id: null,
      });

      const incomingTransfers = await getIncomingTransfers();

      setTransfers(incomingTransfers.data);

      const guestLists = await getGuestList(
        encodeURIComponent(user?.phoneNumber)
      );

      setGuestLists(guestLists.data);
      hideLoading();
    } catch (err) {
      console.error(err);
      hideLoading();
    }
  };

  const acceptTransfer = (transfer) => {
    // save id of transfer
    setIsAccepting({
      accepting: true,
      id: transfer.id,
    });
    let data = {
      transferId: transfer.id,
    };
    acceptIncomingTransfers(data)
      .then((res) => {
        getMyTickets();
      })
      .catch((err) => {
        console.error(err);
        setIsAccepting({
          accepting: false,
          id: null,
        });
      });
  };

  return (
    <>
      {isLoading ? (
        <PageLoadingContainer />
      ) : (
        <section className="spacer-xs background-gradient">
          {!location.pathname.includes("event-details") && (
            <div className="section-heading-sm">
              <h1>My events</h1>
              {!isScalper && (
                <div className="tablet-desktop-only">
                  {key !== "packages" && (
                    <SwiperNavigationButtons
                      navigationPrevRef={navigationPrevRef}
                      navigationNextRef={navigationNextRef}
                    />
                  )}
                </div>
              )}
            </div>
          )}
          {!isScalper ? (
            <Tabs
              defaultActiveKey="upcoming"
              variant="pills"
              activeKey={key}
              onSelect={(k) => setKey(k)}
              className="nav-pills-default"
              justify
            >
              <Tab eventKey="upcoming" title="Upcoming Events">
                {(eventOrders.length > 0 &&
                  eventOrders?.some((o) => o?.tickets?.length > 0)) ||
                transfers.length > 0 ||
                guestLists.length > 0 ? (
                  <MyEventsSlider
                    navigationPrevRef={navigationPrevRef}
                    navigationNextRef={navigationNextRef}
                    orders={eventOrders}
                    transfers={transfers}
                    acceptTransfer={acceptTransfer}
                    isAccepting={isAccepting}
                    guestLists={guestLists}
                  />
                ) : (
                  <EmptyContainer>
                    <h1>You do not have any events</h1>
                  </EmptyContainer>
                )}
              </Tab>
              <Tab eventKey="packages" title="Packages">
                {packageOrders.length > 0 ? (
                  <PackagesList orders={packageOrders} />
                ) : (
                  <EmptyContainer>
                    <h1>You do not have any packages</h1>
                  </EmptyContainer>
                )}
              </Tab>
            </Tabs>
          ) : (
            <>
              {(orders.length > 0 &&
                orders?.some((o) => o?.tickets?.length > 0)) ||
              transfers.length > 0 ||
              guestLists.length > 0 ? (
                <EventsList
                  orders={orders}
                  transfers={transfers}
                  acceptTransfer={acceptTransfer}
                  isAccepting={isAccepting}
                  guestLists={guestLists}
                  getMyTickets={getMyTickets}
                />
              ) : (
                <EmptyContainer>
                  <h1>You do not have any events</h1>
                </EmptyContainer>
              )}
            </>
          )}
        </section>
      )}
    </>
  );
}
